import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import ContactTable from '../components/ContactTable';

const i18nPrefix = 'ContactTable';

class Contact extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;

    return (
      <Container style={{ maxHeight: 'none' }}>
        <Row>
          <Col sm={9}>
            <div style={{ overflow: 'hidden' }}>
              <h1 style={{ float: 'left' }}>{t(`${i18nPrefix}.title`)}</h1>
            </div>
          </Col>
        </Row>

        <ContactTable />
      </Container>
    );
  }
}

export default withTranslation()(Contact);
